import template from './modalCadastralReference.html';
import controller from './modalCadastralReference.controller';
import './modalCadastralReference.scss';

let modalCadastralReferenceComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    onSave: '&',
    loanResponseId: '<',
    simulation: '<',
    closeModalCadastral: '&',
    tempLoanObject: '<',
  },
  template,
  controller,
};

export default modalCadastralReferenceComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalCadastralReference/modalCadastralReference.component.js